import Button from 'Component/Button';
import Icons from 'Component/Icons';
import ShareIcon from 'Component/ShareIcon';
import { MyAccountMyWishlist as SourceMyAccountMyWishlist } from 'SourceComponent/MyAccountMyWishlist/MyAccountMyWishlist.component';

/** @namespace Advox/Component/MyAccountMyWishlist/Component */
export class MyAccountMyWishlist extends SourceMyAccountMyWishlist {
    renderClearWishlist() {
        const { removeAll, isActionsDisabled } = this.props;

        return (
            <Button
                mix={{ block: 'MyAccountMyWishlist', elem: 'ClearWishlistButton' }}
                onClick={removeAll}
                disabled={isActionsDisabled}
                variant="likeLink"
                iconBefore={<Icons name="trash" fill="#797979" width="16px" />}
            >
                {__('Clear All')}
            </Button>
        );
    }

    renderShareWishlistButton() {
        const { isMobile, isTablet, isWishlistLoading, shareWishlist, isWishlistEmpty } = this.props;

        const disabled = isWishlistLoading || isWishlistEmpty;

        return (
            <Button
                mix={{ block: 'MyAccountMyWishlist', elem: 'ShareWishlistButton' }}
                onClick={shareWishlist}
                disabled={disabled}
                variant="outlineInverse"
            >
                {!isMobile && !isTablet && __('Share')}
                {(isMobile || isTablet) && <ShareIcon isPrimary />}
            </Button>
        );
    }

    renderActionBar() {
        const { isActionsDisabled } = this.props;
        if (isActionsDisabled) {
            return null;
        }

        return (
            <div block="MyAccountMyWishlist" elem="ActionBar">
                {this.renderShareWishlistButton()}
                {this.renderAddAllToCart()}
                {this.renderClearWishlist()}
            </div>
        );
    }

    render() {
        return (
            <div block="MyAccountMyWishlist">
                {this.renderShareWishlist()}
                {this.renderActionBar()}
                {this.renderContent()}
            </div>
        );
    }
}

export default MyAccountMyWishlist;
